<template lang="pug">
    aside.ui(:class='{menuactive: menuOpened}')
        Menu(:class='{active: menuOpened}', v-on:closemenu='closeMenu', v-on:openrules='() => rulesOpened = true')
        Rules(:class='{active: rulesOpened}', v-on:closerules='() => rulesOpened = false')
        Auth

        .ui__menu-link.menu-link(@click='toggleMenu', ref='menulink')
            b(v-for='row in 3')

        .ui__share
            .ui__share-button(@click='toggleShare')
                svg(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 37.89 42.94' width='37.89' height='42.94')
                    circle(cx='6.69' cy='21.49' r='6.69')
                    circle(cx='31.19' cy='36.25' r='6.69')
                    circle(cx='31.19' cy='6.69' r='6.69')
                    path(d='M3.634 23.127l2.23-3.863 28.787 16.62-2.23 3.863z')
                    path(d='M3.663 20.044L32.45 3.424l2.23 3.862-28.787 16.62z')

            Share(:class='{active: shareOpened, menuactive: menuOpened}')

        .ui__account
            .ui__account-button(
                :class='{animate: pageLoaded}'
                @click='setAuth'
                )
                p(v-html='authState ? "ВЫХОД" : "ВХОД"')

                svg(width='20', height='20', xmlns='http://www.w3.org/2000/svg' viewBox='0 0 37.1 32.88')
                    path(d='M34.62 32.88H6.71a2.49 2.49 0 01-2.48-2.49v-4.14h1.5v4.14a1 1 0 001 1h27.89a1 1 0 001-1V2.49a1 1 0 00-1-1H6.71a1 1 0 00-1 1v4.36H4.23V2.49A2.49 2.49 0 016.71 0h27.91a2.49 2.49 0 012.48 2.49v27.9a2.49 2.49 0 01-2.48 2.49z')
                    path(:class='{animate: authState}' fill='#1d1d1b' d='M25.79 16.56l-1.12-1.12-.01.01-8-8-1.12 1.12 7.18 7.19H0v1.63h22.72l-7.18 7.18 1.12 1.13 8-8.01.01.01 1.12-1.12-.01-.01.01-.01z')
</template>

<script>
import {mapGetters} from 'vuex';
const Share = () => import('@/components/Share.vue');
const Menu = () => import('@/components/Menu.vue');
const Rules = () => import('@/components/Rules.vue');
const Auth = () => import('@/components/Auth.vue');

export default {
    name: 'Ui',

    components: {
        Share,
        Menu,
        Auth,
        Rules
    },

    data() {
        return {
            shareOpened: false,
            menuOpened: false,
            rulesOpened: false,
            lastThemeColor: '--theme: #fff',
            showMenuIcon: true
        };
    },

    computed: {
        ...mapGetters(['pageLoaded', 'getShowBlock']),

        authState() {
            if (this.$store.state.login.status) {
                return true;
            } else {
                return false;
            }
        },
        isMobile() {
            return document.documentElement.clientWidth < 425;
        }
    },

    watch: {
        menuOpened(state) {
            if (state) {
                this.lastThemeColor = document.body.getAttribute('style');
                document.body.setAttribute('style', '--theme: #fff');
            } else {
                document.body.setAttribute('style', this.lastThemeColor);
            }
        },

        $route(to) {
            // прячем иконку меню, если при переходе активен раздел с конкурсанткой
            this.showMenuIcon = to.name && to.name === 'Profile' ? false : true;
        }
    },

    mounted() {
        // прячем иконку меню, если при загрузке активен раздел с конкурсанткой
        this.showMenuIcon = this.$route.name && this.$route.name === 'Profile' ? false : true;
    },

    methods: {
        toggleMenu() {
            this.$refs.menulink.classList.add('animate');
            setTimeout(() => {
                this.$refs.menulink.classList.remove('animate');
            }, 800);
            this.menuOpened = !this.menuOpened;

            this.$analytics.sendEvent({
                event: 'eventTracking',
                category: 'Button',
                action: 'click',
                label: 'Menu Button'
            });
        },

        closeMenu() {
            this.menuOpened = document.body.clientWidth <= 768 ? false : true;
        },

        toggleShare() {
            this.shareOpened = !this.shareOpened;

            this.$analytics.sendEvent({
                event: 'eventTracking',
                category: 'Button',
                action: 'click',
                label: 'Share Button'
            });
        },

        setAuth() {
            if (this.$store.state.login.status) {
                this.$store.commit('logout');

                this.$analytics.sendEvent({
                    event: 'eventTracking',
                    category: 'Button',
                    action: 'click',
                    label: 'Logout'
                });
            } else {
                this.$store.commit('setAuth', true);

                this.$analytics.sendEvent({
                    event: 'eventTracking',
                    category: 'Button',
                    action: 'click',
                    label: 'Login'
                });
            }
        }
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars.scss';

@keyframes showAuthBtn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes slideLeftRight {
    0% {
        transform: scaleX(1);
        transform-origin: 100% 0;
    }

    49.9% {
        transform: scaleX(0);
        transform-origin: 100% 0;
    }

    50% {
        transform: scaleX(0);
        transform-origin: 0% 0;
    }

    100% {
        transform: scaleX(1);
        transform-origin: 0% 0;
    }
}

@keyframes slideLeftRightHalf {
    0% {
        transform: scaleX(1);
        transform-origin: 100% 0;
    }

    49.9% {
        transform: scaleX(0);
        transform-origin: 100% 0;
    }

    50% {
        transform: scaleX(0);
        transform-origin: 0% 0;
    }

    100% {
        transform: scaleX(0.5);
        transform-origin: 0% 0;
    }
}

.ui {
    position: fixed;
    // z-index: 21;
    z-index: 19;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    padding: 7vh 35px 32px;
    pointer-events: none;

    &__menu-link {
        position: relative;
        z-index: 18;
        width: 30px;
        height: 21px;
        display: none;
        flex-direction: column;
        justify-content: space-between;
        cursor: pointer;
        pointer-events: all;
        overflow: hidden;

        b {
            display: inline-block;
            width: 30px;
            height: 3px;
            background: black;
            transform-origin: 0%;
            transition: transform 0.3s ease-in-out;

            &:nth-child(1) {
                transform-origin: 100% 0;
            }

            &:nth-child(3) {
                transform: scaleX(0.75);
            }
        }

        &:hover {
            b {
                &:nth-child(1) {
                    transform: scaleX(0.75);
                }

                &:nth-child(3) {
                    transform: scaleX(1);
                }
            }
        }

        &.animate {
            b {
                &:nth-child(1) {
                    animation: slideLeftRight 0.6s ease-in-out;
                }

                &:nth-child(2) {
                    animation: slideLeftRight 0.6s 0.1s ease-in-out;
                }

                &:nth-child(3) {
                    animation: slideLeftRightHalf 0.6s 0.2s ease-in-out;
                }
            }
        }
    }

    &__share {
        position: relative;
        z-index: 18;
        grid-column: 1;
        grid-row: 2;

        &-button {
            display: none;

            svg {
                width: 25px;
                height: 28.21px;
            }
        }
    }

    &__account {
        position: relative;
        z-index: 18;
        grid-column: 2;
        grid-row: 2;

        &-button {
            position: absolute;
            right: 0;
            bottom: 0;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            pointer-events: all;
            cursor: pointer;

            opacity: 0;
            transform: translateY(50px);
            transition: opacity 0.6s ease 2.8s, transform 1.6s ease-out 2.2s;

            &.animate {
                opacity: 1;
                transform: translateY(0px);
            }

            svg {
                margin-left: 20px;
                fill: black;

                path {
                    &:nth-child(2) {
                        transition: transform 0.6s ease;
                        transform-origin: 35% center;
                    }

                    &.animate {
                        transform: rotate(180deg);
                    }
                }
            }
        }
    }

    &.menuactive {
        .ui {
            &__menu-link {
                b {
                    background: #fff;
                }
            }

            &__share {
                .dot {
                    background-color: white;

                    &:before {
                        background-color: white;
                    }
                }
            }

            &__account {
                svg {
                    fill: black;
                }
            }
        }
    }

    @media (--viewport-tablet) {
        padding: 3vh 3vw;

        &__share {
            &-button {
                display: block;
                position: absolute;
                bottom: 0;
                left: 0;
                cursor: pointer;
                pointer-events: all;
            }
        }

        &__menu-link {
            display: flex;
            grid-column: 1;
            justify-self: start;

            &.hide {
                pointer-events: none;
                opacity: 0;
            }
        }

        &__account {
            &-button {
                font-size: 2.5vw;
                line-height: 1;
                top: auto;
                bottom: 0;

                svg {
                    display: none;
                }
            }
        }

        &.menuactive {
            .ui {
                &__share-button {
                    fill: white;
                }

                &__account {
                    &-button {
                        color: white;
                    }
                }
            }
        }
    }

    @media (--viewport-mobile-l) {
        &__account {
            &-button {
                font-size: 5vw;
                padding: 10px 0 0 10px;
            }
        }
        &__share {
            &-button {
                padding: 10px 10px 0 0;

                svg {
                    width: 30px;
                    height: 34px;
                }
            }
        }
    }
}
</style>
